import React from 'react';
import ShopOnlineContent from '../components/ShopOnlineContent';

const ShopOnline = () => {
  return <ShopOnlineContent/>;
};

export default ShopOnline;
